export const formatCurrency = (num: number, max: number = 2, withSign: boolean = false): string =>
  (withSign ? (num > 0 ? '+ ' : '- ') : '') + num.toLocaleString('en-EN', { maximumSignificantDigits: max });

export const checkNumberPrice = (strPrice: string): number => {
  let numPrice = Number.parseFloat(strPrice);
  return !Number.isNaN(numPrice) ? numPrice : 0;
};

export const getPriceInFormat = (price: string): string => formatCurrency(checkNumberPrice(price));
